import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { MissingFieldException24tqif29emcmi as MissingFieldException } from '../SerializationExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function throwMissingFieldException(seen, goldenMask, descriptor) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var missingFields = ArrayList().w();
  var missingFieldsBits = goldenMask & ~seen;
  var inductionVariable = 0;
  if (inductionVariable < 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!((missingFieldsBits & 1) === 0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element = descriptor.v11(i);
        missingFields.v(element);
      }
      missingFieldsBits = missingFieldsBits >>> 1 | 0;
    }
     while (inductionVariable < 32);
  throw MissingFieldException().f11(missingFields, descriptor.h10());
}
function throwArrayMissingFieldException(seenArray, goldenMaskArray, descriptor) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var missingFields = ArrayList().w();
  var inductionVariable = 0;
  var last = goldenMaskArray.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var maskSlot = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var missingFieldsBits = goldenMaskArray[maskSlot] & ~seenArray[maskSlot];
      if (!(missingFieldsBits === 0)) {
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 32)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!((missingFieldsBits & 1) === 0)) {
              // Inline function 'kotlin.collections.plusAssign' call
              var element = descriptor.v11(imul(maskSlot, 32) + i | 0);
              missingFields.v(element);
            }
            missingFieldsBits = missingFieldsBits >>> 1 | 0;
          }
           while (inductionVariable_0 < 32);
      }
    }
     while (inductionVariable <= last);
  throw MissingFieldException().f11(missingFields, descriptor.h10());
}
//region block: exports
export {
  throwArrayMissingFieldException as throwArrayMissingFieldExceptionbk1mj238w44a,
  throwMissingFieldException as throwMissingFieldException2cmke0v3ynf14,
};
//endregion

//# sourceMappingURL=PluginExceptions.mjs.map
